module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00044-fs8.3f6dc4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00044-fs8.png
// module id = 197
// module chunks = 0